/**
 * @type {import('gatsby').GatsbyBrowser}
 */
// Tylko używane wagi (300-800; 200 nieużywana) i tylko subsety latin +
// latin-ext (polskie znaki) — pełne importy ładowały też cyrylicę, grekę
// i wietnamski, pompując HTML o setki KB wbudowanych fontów.
import '@fontsource/manrope/latin-300.css'
import '@fontsource/manrope/latin-ext-300.css'
import '@fontsource/manrope/latin-400.css'
import '@fontsource/manrope/latin-ext-400.css'
import '@fontsource/manrope/latin-500.css'
import '@fontsource/manrope/latin-ext-500.css'
import '@fontsource/manrope/latin-600.css'
import '@fontsource/manrope/latin-ext-600.css'
import '@fontsource/manrope/latin-700.css'
import '@fontsource/manrope/latin-ext-700.css'
import '@fontsource/manrope/latin-800.css'
import '@fontsource/manrope/latin-ext-800.css'

import './src/styles/global.scss'

export const onRouteUpdate = ({ location }) => {
  if (location.hash) {
    const element = document.querySelector(location.hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
  }

  requestAnimationFrame(() => {
    window.scrollTo(0, 0);
  });
};
